/**
 * PORTED — RO-3-00 / #44398.
 * Origin: `excellent/app/customers/_scope-actions.tsx` (verbatim except the two
 * import paths). Same shape as the Finance reference wiring; see
 * `finance-scope-actions.tsx` for why the three stay separate files.
 */

import { DataScopeActions } from "@excellent/ui";
import { DataImportClient } from "../data-import/client";
import { ObjectsIndexClient, type ObjectKindRow } from "./objects-index-client";
import { CUSTOMERS_KINDS } from "./scope-kinds";

export function CustomersScopeActions({ rawRows }: { rawRows: ObjectKindRow[] }) {
  return (
    <DataScopeActions
      entityLabel="Customers"
      importDescription="Upload a CSV, TSV, or JSON of leads and contacts — rows land as leads, people, and organizations via the Schema, deduped by email."
      import={<DataImportClient targetKind="crm-leads" />}
      rawDataDescription="The lead, person, and organization tables behind this page, scoped to Customers."
      rawData={
        <ObjectsIndexClient
          rows={rawRows}
          scopeKinds={[...CUSTOMERS_KINDS]}
          chromeless
        />
      }
    />
  );
}
